import React, { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext(null);
const STORAGE_KEY = "rs_user";
const CLIENT_ID = process.env.REACT_APP_GOOGLE_CLIENT_ID || "";

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    try {
      const saved = localStorage.getItem(STORAGE_KEY);
      if (saved) setUser(JSON.parse(saved));
    } catch (_e) {}
    setLoading(false);
  }, []);

  useEffect(() => {
    if (!CLIENT_ID) return;
    const interval = setInterval(() => {
      if (!window.google) return;
      clearInterval(interval);
      window.google.accounts.id.initialize({
        client_id: CLIENT_ID,
        callback: ({ credential }) => {
          try {
            const payload = JSON.parse(atob(credential.split(".")[1]));
            const u = {
              user_id: payload.sub,
              email: payload.email,
              name: payload.name,
              picture: payload.picture,
            };
            setUser(u);
            localStorage.setItem(STORAGE_KEY, JSON.stringify(u));
          } catch (_e) {}
        },
        auto_select: false,
      });
    }, 100);
    return () => clearInterval(interval);
  }, []);

  const login = () => {
    if (!CLIENT_ID) {
      alert("Google Client ID not configured. Set REACT_APP_GOOGLE_CLIENT_ID in Cloudflare Pages environment variables.");
      return;
    }
    if (window.google) {
      window.google.accounts.id.prompt((notification) => {
        if (notification.isNotDisplayed() || notification.isSkippedMoment()) {
          // One Tap was suppressed — fall back to renderButton flow
          const btn = document.getElementById("g_id_signin_fallback");
          if (btn) btn.click();
        }
      });
    }
  };

  const logout = () => {
    if (window.google && CLIENT_ID) {
      window.google.accounts.id.disableAutoSelect();
    }
    localStorage.removeItem(STORAGE_KEY);
    setUser(null);
  };

  return (
    <AuthContext.Provider value={{ user, setUser, loading, login, logout }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  const ctx = useContext(AuthContext);
  if (!ctx) throw new Error("useAuth must be used within AuthProvider");
  return ctx;
}
